module.exports = __webpack_public_path__ + "static/media/apache.cfa349ac.png";